import { useTranslation } from 'react-i18next';
import { FiUsers } from 'react-icons/fi';
import { LuCalendarCheck, LuClock, LuCalendarDays, LuMapPin } from 'react-icons/lu';
import { MdOutlinePushPin } from 'react-icons/md';
import { RiErrorWarningLine } from 'react-icons/ri';
import styled from 'styled-components';
import { getColors, isAquiEstoy } from 'utils/contants';
import config from '../../../config';
import { Progress } from '@chakra-ui/react';

const Span = styled.span`
  padding: 5px 15px;
  margin: 10px 0px;
  font-size: 13px;
  background-color: ${(props) => getColors(props.color).backgroundColor};
  color: ${(props) => getColors(props.color).color};
  border-radius: 40px;
  text-align: center;
  align-self: start;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Detail = ({ activity, showLocation = false }) => {
  const addHours = (newDate) => {
    const date = new Date(newDate);
    const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    const formattedDate = adjustedDate.toLocaleDateString('es-ES');
    return formattedDate;
  };

  const { t } = useTranslation();

  const unlimitedQuota = activity.quota === 0;

  const availablePlaces = unlimitedQuota ? null : activity.quota - activity.occupied_quota;

  const getLocation = () => {
    if (activity.locations && activity.locations.length) {
      if (showLocation) {
        return activity.locations.map((loc) => <div key={`adressKey-${loc.id}`}>{loc.address}</div>);
      }
      return activity.locations && activity.locations.length === 1 ? activity.locations[0].address : 'Multiple';
    }
    return 'Sin asignar';
  };

  return (
    <Container>
      {!config.profile_globant && <Span color={activity.color_alternative_type}>{activity.alternative_type}</Span>}

      {activity.continuous_activity ? (
        <div>
          {config.profile_globant && <LuCalendarCheck />}
          <span
            style={config.profile_globant ? { fontSize: '13px', paddingLeft: '3px' } : { fontSize: '14px' }}
            className={config.profile_globant ? '' : 'strong text-dark'}
          >
            {t('home.card_msg7')}
          </span>
        </div>
      ) : (
        <div>
          {!config.profile_globant ? (
            <div className="my-1">
              <MdOutlinePushPin className="text-primary mr-1" />
              <span className="strong" style={{ fontSize: '14px' }}>
                {t('home.card_msg2')}:
              </span>
              <span style={{ fontSize: '14px' }}>{activity.deadline.slice(0, 10)}</span>
            </div>
          ) : (
            <div>
              <div>
                <LuCalendarCheck />
                <span style={{ fontSize: '13px', paddingLeft: '3px' }} className="strong">
                  {t('home.card_msg1')}:
                </span>
                <span style={{ fontSize: '13px', color: '#5B5B5B' }}>
                  {activity.activity_from === activity.activity_to
                    ? addHours(activity.activity_from)
                    : `del ${addHours(activity.activity_from)} al ${addHours(activity.activity_to)}`}
                </span>
              </div>
              <div>
                <RiErrorWarningLine />
                <span style={{ fontSize: '13px', paddingLeft: '3px' }} className="strong">
                  {t('home.card_msg2')}:
                </span>
                <span style={{ fontSize: '13px', color: '#5B5B5B' }}>{addHours(activity.deadline.slice(0, 10))}</span>
              </div>
            </div>
          )}
        </div>
      )}
      {activity.quota >= 0 && (
        <div>
          {!config.profile_globant && activity.quota > 0 && (
            <div className="my-1">
              <span className="text-uppercase" style={{ fontSize: '14px' }}>
                {`${t('home.card_msg8')}: ${availablePlaces}/${activity.quota}`}
              </span>
              <Progress
                value={availablePlaces}
                max={activity.quota}
                colorScheme="green"
                size="sm"
                borderRadius="md"
                mt={1}
              />
            </div>
          )}
          {!config.profile_globant && activity.quota === 0 && (
            <div className="my-1">
              <span className="text-uppercase" style={{ fontSize: '14px' }}>
                {`${t('home.card_msg9')} - ${t('home.card_msg10')}: ${activity.occupied_quota}`}
              </span>
            </div>
          )}
        </div>
      )}

     
          {!!activity.quota && config.profile_globant && (
            <div>
              <FiUsers />
              <span style={{ fontSize: '13px', paddingLeft: '3px' }} className="strong">
                {t('home.card_msg3')}:
              </span>
              <span style={{ fontSize: '13px', color: '#5B5B5B' }}>{activity.quota}</span>
            </div>
          )}

      <div className="d-flex justify-content-between my-1">
        {activity.estimated_hours && !config.profile_globant ? (
          <div className="d-flex align-items-center">
            <LuClock className="mr-1" />
            {/* <span className="strong">{t('home.card_msg6')}:</span> */}
            <span style={{ fontSize: '14px' }}> {`${activity.estimated_hours} ${t('hours.hours_msg4')}`}</span>
          </div>
        ) : null}

        {!config.profile_globant && (
          <div>
            {activity.activity_from && activity.activity_to ? (
              activity.activity_from === activity.activity_to ? (
                <div className="d-flex align-items-center">
                  <LuCalendarDays className="text-primary mr-1" />
                  <span style={{ fontSize: '14px' }}>{activity.activity_from}</span>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <LuCalendarDays className="text-primary mr-1" />
                  <span style={{ fontSize: '14px' }}>
                    {activity.activity_from} al {activity.activity_to}
                  </span>
                </div>
              )
            ) : null}
          </div>
        )}
      </div>
      {config.activities?.card?.weAreIn && !config.profile_globant && !isAquiEstoy && (
        <div className="d-flex align-items-center my-1">
          <LuMapPin className="text-primary mr-1" />
          {/* <span className="strong">{t('home.card_msg4')}:</span> */}
          <span style={{ fontSize: '14px' }}>{getLocation()}</span>
        </div>
      )}
    </Container>
  );
};
export default Detail;
